import "./StepCounter.scss";
import OuterCircleStroke from "./icons/OuterCircleStroke";
import InnerCircle from "./icons/InnerCircle";

interface Props {
  current: number;
  total: number;
}

export default function StepCounter({ current, total }: Props) {
  return <div className={"step-counter"}>
    {Array.from({ length: total }).map((_, i) => (
      <div key={i}>
        <div className={i + 1 === current ? "active" : ""}>
          <OuterCircleStroke />
          <InnerCircle />
          <span>{i + 1}</span>
        </div>
        {i + 1 < total && <div className={"sep"}></div>}
      </div>
    ))}
  </div>;
}
